import React from "react";
import { Form, Input, Select, message } from "antd";
import FormModal from "../../../components/FormModal";
import PasswordFields from "../../../components/PasswordFields";
import { extractMsg } from "../../../utils/errorUtils";

export function AddUserDialog({ open, onClose, onSave }) {
  const [form] = Form.useForm();
  return (
    <FormModal
      title="Add New User"
      open={open}
      onClose={() => {
        form.resetFields();
        onClose();
      }}
      onFinish={async (values) => {
        try {
          await onSave(values);
          form.resetFields();
        } catch (error) {
          message.error(extractMsg(error, "Failed to add user"));
          console.error("Failed to add user", error);
        }
      }}
      form={form}
      submitText="Save"
      width={600}
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: "email" }]}
      >
        <Input placeholder="Enter email address" />
      </Form.Item>
      <Form.Item
        name="username"
        label="Username"
        rules={[{ required: true, min: 6, max: 30 }]}
      >
        <Input placeholder="Enter username" />
      </Form.Item>
      <PasswordFields />
      <Form.Item name="roles" label="Role" rules={[{ required: true }]}>
        <Select placeholder="Select a role">
          <Select.Option value="ROLE_USER">User</Select.Option>
          <Select.Option value="ROLE_ADMIN">Admin</Select.Option>
          <Select.Option value="ROLE_MANAGER">Manager</Select.Option>
        </Select>
      </Form.Item>
    </FormModal>
  );
}

export function UpdateUserDialog({ open, user, onClose, onSave }) {
  const [form] = Form.useForm();
  return (
    <FormModal
      title="Edit User"
      open={open}
      onClose={onClose}
      onFinish={async (values) => {
        try {
          await onSave(user.id, values);
        } catch (error) {
          message.error(extractMsg(error, "Failed to update user"));
          console.error("Failed to update user", error);
        }
      }}
      form={form}
      submitText="Update User"
      width={600}
      initialValues={
        user
          ? {
              email: user.email,
              username: user.username,
              role: user.roles?.length ? user.roles[0].name : "ROLE_USER",
            }
          : undefined
      }
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: "email" }]}
      >
        <Input placeholder="Enter email address" />
      </Form.Item>
      <Form.Item
        name="username"
        label="Username"
        rules={[{ required: true, min: 6, max: 30 }]}
      >
        <Input placeholder="Enter username" />
      </Form.Item>
      <PasswordFields required={false} />
      <Form.Item name="role" label="Role" rules={[{ required: true }]}>
        <Select placeholder="Select a role">
          <Select.Option value="ROLE_USER">User</Select.Option>
          <Select.Option value="ROLE_ADMIN">Admin</Select.Option>
          <Select.Option value="ROLE_MANAGER">Manager</Select.Option>
        </Select>
      </Form.Item>
    </FormModal>
  );
}
